import { TransactionsContextType } from "@zenith/context/global-context/types";
import { memo } from "react";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";
import { formatCurrency } from "@zenith/utils";
import { OperationFullDTO } from "@zenith/services/transactions";
import {
  shouldShow,
  isPaymentLinkPayWithTransfer,
  truncateText,
} from "@zenith/utils/TransactionDisplayHelpers";

export interface BankTransferTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const BankTransferTransactionDetails = memo(
  function BankTransferTransactionDetails(
    props: BankTransferTransactionDetailsProps
  ) {
    const { transaction } = props;
    const isFeeTransaction = transaction?.partialTransactionType?.toUpperCase() === "FEE";
    const paymentMethod = transaction?.paymentMethod;
    const paymentMethodString = paymentMethod as string;

    const isPayWithTransfer = 
      paymentMethod === OperationFullDTO.paymentMethod.PAY_WITH_TRANSFER ||
      paymentMethodString === "PAY_WITH_TRANSFER" ||
      isPaymentLinkPayWithTransfer(paymentMethodString);

    if (isFeeTransaction) {
      return (
        <>
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Amount</p>
            <p className="font-medium text-neutral-900">
              {formatCurrency(transaction?.totalAmount, true)}
            </p>
          </div>
        </>
      );
    }

    return (
      <>
        {shouldShow(transaction?.beneficiaryName) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Payer's Name</p>
            <p className="font-medium text-neutral-900">
              {transaction?.beneficiaryName}
            </p>
          </div>
        )}

        {shouldShow(transaction?.bankName) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Payer's Bank</p>
            <p className="font-medium text-neutral-900">
              {transaction?.bankName}
            </p>
          </div>
        )}

        {/* {shouldShow(transaction?.beneficiaryAccountNumber) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Payer's Account</p>
            <CopyToClipboard
              text={transaction?.beneficiaryAccountNumber}
            />
          </div>
        )} */}

        {isPayWithTransfer && shouldShow(transaction?.transferAccountNumber) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Transfer Account</p>
            <CopyToClipboard text={transaction?.transferAccountNumber} />
          </div>
        )}

        {isPayWithTransfer && shouldShow(transaction?.accountCredited) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Merchant Account</p>
            <CopyToClipboard text={transaction?.accountCredited} />
          </div>
        )}

        {shouldShow(transaction?.sessionId) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Session ID</p>
            <CopyToClipboard text={transaction?.sessionId} />
          </div>
        )}

        {shouldShow(transaction?.description) && (
          <div className="mb-2 flex justify-between">
            <p className="text-neutral-600">Description</p>
            <div className="w-3/5 text-right">
              <p className="font-medium text-neutral-900 break-words">
                {truncateText(transaction?.description)}
              </p>
            </div>
          </div>
        )}
      </>
    );
  }
);

export default BankTransferTransactionDetails;